const mxCache = new Map<string, Promise<boolean>>();

/** RFC 7505 "null MX" — a domain explicitly declaring it accepts no mail (e.g. `0 .`). */
const isNullMx = (exchange: string): boolean => {
  const normalized = exchange.trim().replace(/^\d+\s+/, '');
  return normalized === '.' || normalized === '';
};

const fetchHasMx = async (domain: string): Promise<boolean> => {
  try {
    const response = await fetch(`https://dns.google/resolve?name=${encodeURIComponent(domain)}&type=MX`);
    const data = await response.json();

    if (!Array.isArray(data.Answer) || data.Answer.length === 0) {
      return false;
    }

    return data.Answer.some((record: { data?: string }) => !isNullMx(record.data ?? ''));
  } catch {
    // DNS-over-HTTPS lookup failed (network hiccup, API unavailable) — fail open, never block a real user on this.
    return true;
  }
};

export const domainHasMxRecord = (domain: string): Promise<boolean> => {
  const key = domain.toLowerCase();

  const cached = mxCache.get(key);
  if (cached) {
    return cached;
  }

  const promise = fetchHasMx(key);
  mxCache.set(key, promise);
  return promise;
};
